import {useNavigate} from "react-router-dom";
import "./AttendanceTable.css";

export default function AttendanceTable({data = []}) {
    const navigate = useNavigate();

    const getUserStatuses = (user) => {
        // Agar umuman kelmagan bo‘lsa
        if (
            !user.date ||
            (!user.date.entry_time && !user.date.leave_time)
        ) {
            return [{ id: "absent", name: "absent" }];
        }

        return user.date.status?.length > 0
            ? user.date.status
            : [];
    };

    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString() : "-";

    const formatTime = (date) =>
        date
            ? new Date(date).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
            })
            : "-";

    return (
        <div className="table-wrapper">
            <table>
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Date</th>
                    <th>Entry</th>
                    <th>Leave</th>
                    <th>Status</th>
                </tr>
                </thead>

                <tbody>
                {data.length === 0 ? (
                    <tr>
                        <td colSpan="5" className="empty">
                            No data
                        </td>
                    </tr>
                ) : (
                    data.map((user) => (
                        <tr
                            key={user.id}
                            className="clickable-row"
                            onClick={() =>
                                navigate(`/user/${user.id}`)
                            }
                        >
                            <td>{user.name}</td>

                            <td>
                                {user.role_id === 4
                                    ? "Student"
                                    : user.role_id === 6
                                        ? "Teacher"
                                        : "Unassigned"}
                            </td>

                            <td>
                                {user.date
                                    ? formatDate(user.date.date)
                                    : "-"}
                            </td>

                            <td>
                                {user.date
                                    ? formatTime(
                                        user.date.entry_time
                                    )
                                    : "-"}
                            </td>

                            <td>
                                {user.date
                                    ? formatTime(
                                        user.date.leave_time
                                    )
                                    : "-"}
                            </td>
                            <td>
                                <div className="status-wrapper">
                                    {getUserStatuses(user).map((s) => (
                                        <span
                                            key={s.id}
                                            className={`status-badge ${
                                                s.name === "came on time"
                                                    ? "green"
                                                    : s.name === "late"
                                                        ? "orange"
                                                        : s.name === "left early"
                                                            ? "red"
                                                            : s.name === "left on time"
                                                                ? "blue"
                                                                : s.name === "absent"
                                                                    ? "dark"
                                                                    : "gray"
                                            }`}
                                        >
        {s.name}
      </span>
                                    ))}
                                </div>
                            </td>


                        </tr>
                    ))
                )}
                </tbody>
            </table>
        </div>
    );
}
